import { render, staticRenderFns } from "./virtual-point-setting.vue?vue&type=template&id=510fc4f0&scoped=true&"
import script from "./virtual-point-setting.vue?vue&type=script&lang=js&"
export * from "./virtual-point-setting.vue?vue&type=script&lang=js&"
import style0 from "./virtual-point-setting.vue?vue&type=style&index=0&id=510fc4f0&lang=scss&scoped=true&"
import style1 from "./virtual-point-setting.vue?vue&type=style&index=1&id=510fc4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510fc4f0",
  null
  
)

export default component.exports